import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class UsetifulService {
	identifyUser(identificationObj: any): void {
		const usetifulTags = this.convertBooleansToStrings(identificationObj);

		window['usetifulTags'] = {
			...window['usetifulTags'],
			...usetifulTags,
		};

		this.loadScript();
	}

	loadScript(): void {
		const scriptId = 'usetifulScript';
		const hasScript = document.getElementById(scriptId);

		if (!hasScript) {
			const docHeader = document.getElementsByTagName('head')[0];
			const script = document.createElement('script');

			script.async = true;
			script.src = 'https://www.usetiful.com/dist/usetiful.js';
			script.setAttribute('id', scriptId);
			script.dataset.token = environment.usetifulToken;

			docHeader.appendChild(script);
		}
	}

	convertBooleansToStrings(obj) {
		const convertedObj = {};

		for (const key in obj) {
			if (typeof obj[key] === 'boolean') {
				convertedObj[key] = obj[key].toString();
			}
		}

		return { ...obj, ...convertedObj };
	}
}
